export default __webpack_public_path__ + "static/media/logo-oegb.e46df538.png";